import React, { useEffect, useState } from "react";

import GoBackHeader from "../GoBackHeader/GoBackHeader";
import Departments from "../Departments/Departments";
import ClinicsList from "../ClinicsList/ClinicsList";
import Footer from "../Footer/Footer";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useDispatch } from "react-redux";
import { ScrollActions } from "../../store/Slices/ScrollSlice";
import ClinicsMobile from "./Mobile/ClinicsMobile";

import axios from "axios";

const Clinics = (props) => {
  gsap.registerPlugin(ScrollTrigger);
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);

  const handleWidthChange = () => {
    // setWidth(window.innerWidth);
    // console.log("mobile", isMobile);
    if (window.innerWidth > 1000) {
      setIsMobile(false);
      // window.location.reload();
    } else if (window.innerWidth <= 1000) {
      setIsMobile(true);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleWidthChange);
    window.scrollTo({ top: 0 });
    return () => {
      dispatch(ScrollActions.setInitial());
    };
  }, []);

  if (!isMobile) {
    return (
      <>
        <GoBackHeader />
        <Departments small={true} />
        <ClinicsList />
        <Footer enableScroll={false} />
        <div id="portal"></div>
      </>
    );
  }else{
    return (
      <>
        <ClinicsMobile/>
      </>
    )
  }
};
export default Clinics;
